var _defs, _path, _path2, _path3, _path4, _polygon, _polygon2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoRedWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 825.06 452.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 100.54,
    y1: 37.62,
    x2: 209.04,
    y2: 37.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bb0b24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1383b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 16.45,
    y1: 37.62,
    x2: 112.11,
    y2: 37.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bb0b24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f121f"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "OHBI LOGO blanco") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.71,513c0-78.28,22.68-107.17,112.76-107.17S347.23,434.67,347.23,513,324.55,620.12,234.47,620.12,121.71,591.23,121.71,513Zm174.89,0c0-57.16-9.94-71.13-62.13-71.13-53.43,0-62.13,14.91-62.13,71.13,0,57.16,9.94,71.14,62.13,71.14C287.9,584.09,296.6,569.18,296.6,513Z",
    transform: "translate(-121.71 -313.55)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M946.77,616.39H896.44V409.51h50.33Z",
    transform: "translate(-121.71 -313.55)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M598.85,616.39H548.53v-84.8H446.64v84.8H396.31V409.51h50.33v84.18H548.53V409.51h50.32Z",
    transform: "translate(-121.71 -313.55)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M804.8,613.29c-11.18,2.48-23,3.1-42.87,3.1H654.76V409.51H763.18c18.32,0,30.75.93,41,3.11,25.47,5.28,38.52,22.67,38.52,48.77,0,24.85-10.56,40.69-30.75,47.21,24.23,7.15,35.72,24.54,35.72,51.57C847.67,588.43,833.69,607.07,804.8,613.29ZM705.09,443.68v50.63h54c12.74,0,16.46-.62,19.26-1.55,11.49-3.73,14.29-13.67,14.29-24.54,0-9-1.25-18.64-14.6-22.68-3.73-1.24-8.7-1.86-19-1.86Zm0,83.25v55.29h55.6c10.87,0,14-.31,17.09-.93C793.93,577.87,797,566.07,797,554c0-12.42-2.17-23-18.63-26.09-3.42-.62-7.46-.93-18.64-.93Z",
    transform: "translate(-121.71 -313.55)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "112.11 42.09 100.54 24.46 112.11 0 173.39 21.04 209.04 75.25 112.11 42.09"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "112.11 42.09 112.11 0 51.64 21.04 16.45 75.25 112.11 42.09"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.18,734.59H219.83v-5.86h31.63v5.86H239.11V766h-6.93Z",
    transform: "translate(-121.71 -313.55)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.62,757.37H287L283.31,766h-7.13L293,728.73h6.81L316.59,766h-7.24Zm-2.29-5.43-7-16.29-7,16.29Z",
    transform: "translate(-121.71 -313.55)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.16,742c0,8.2-6.07,13.25-15.87,13.25h-8.41V766H348V728.73h15.33C373.09,728.73,379.16,733.73,379.16,742Zm-7,0c0-4.69-3.14-7.4-9.21-7.4h-8.09v14.8H363C369,749.39,372.18,746.67,372.18,742Z",
    transform: "translate(-121.71 -313.55)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M478.75,757.37H460.11L456.44,766H449.3l16.77-37.27h6.82L489.71,766h-7.24Zm-2.29-5.43-7-16.29-7,16.29Z",
    transform: "translate(-121.71 -313.55)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M554.2,728.73V766h-5.69L528,740.76V766h-6.86V728.73h5.69L547.33,754V728.73Z",
    transform: "translate(-121.71 -313.55)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M590.85,728.73h16.29c12.09,0,20.34,7.45,20.34,18.63S619.23,766,607.14,766H590.85Zm16,31.41c8.31,0,13.68-5.06,13.68-12.78s-5.37-12.77-13.68-12.77h-9.05v25.55Z",
    transform: "translate(-121.71 -313.55)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M709.71,734.53v11.34h18v5.86h-18V766h-6.92V728.73H730v5.8Z",
    transform: "translate(-121.71 -313.55)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M763.34,728.73h6.92v31.41h19.49V766H763.34Z",
    transform: "translate(-121.71 -313.55)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M834.06,752.85V766h-6.93V753l-14.64-24.22h7.4l10.92,18.16,11-18.16h6.81Z",
    transform: "translate(-121.71 -313.55)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRedWhite);
export default __webpack_public_path__ + "static/media/logoRed&White.626a3be8a53c4241c08b3b3fa1e19317.svg";
export { ForwardRef as ReactComponent };